//自定义组件

import groupTree from "../components/common/groupTree.vue";
import iSwitchLy from "../components/common/iSwitchLy.vue";
import userTree from "../components/common/userTree.vue";
import reportTop from "../../node_modules/common/src/components/sys/reportTop";
import reportTools from "../components/common/reportTools";
import carTool from "../components/common/carTool";
import deviceTool from "../components/common/deviceTool";
import driverTool from "../components/common/driverTool";
import personTool from "../components/common/personTool";
import payTool from "../components/common/payTool";
import timeTool from "../components/common/timeTool";
import jiedian from "../components/common/jiedian";
import selectGroup from "../components/common/selectGroup.vue";
import selectUser from "../components/common/selectUser.vue";
import selectCar from "../components/common/selectCar.vue";
import selectDevice from "../components/common/selectDevice.vue";
import selectCarType from "../components/common/selectCarType.vue";
import selecAlotCCar from "../components/common/selecAlotCCar.vue";
import selectPerson from "../components/common/selectPerson.vue";
import selectCity from "../components/common/selectCity.vue";
import selectDriver from "../components/common/selectDriver.vue";
import selectItems from "../components/common/selectItems.vue";
import selectGrid from "../components/common/selectGrid.vue";
import lyTable from "../../node_modules/common/src/components/lyTable.vue";
import selectFence from "../components/common/selectFence.vue";
import selectPoint from "../components/common/selectPoint.vue";
import selectLine from "../components/common/selectLine.vue";
import lyGroup from "../../node_modules/common/src/components/lyGroup.vue";
import lyItem from "../../node_modules/common/src/components/lyItem.vue";
import lyFormItem from "../../node_modules/common/src/components/lyFormItem.vue";
import lykanbanbox from "../../node_modules/common/src/components/lykanbanbox";
import lyList from "../../node_modules/common/src/components/lyList";
import axiosRes from "../../node_modules/common/src/components/axiosRes";
import lyMap from "../components/map/map";
import pointList from "../components/common/pointList";
import lineList from "../components/common/lineList";
import fenceList from "../components/common/fenceList";
import photo from "../components/common/photo";
import toggle from "../components/common/toggle";
import word from "../../node_modules/common/src/components/word";
import lyPhoto from "../../node_modules/common/src/components/lyPhoto";
import startEnd from "../components/common/startEnd";
import selectAlotGroup from "../components/common/selectAlotGroup";
import searchAdd from "../../node_modules/common/src/components/searchAdd";
import blind from "../components/common/blind";
import selectAddMap from "../../node_modules/common/src/components/selectAddMap";
import Address from "../../node_modules/common/src/components/address";
import AddressList from "../../node_modules/common/src/components/addressList";
import formModel from "../../node_modules/common/src/components/formModel";
import selectTool from "../../node_modules/common/src/components/selectTool";
import lyyymmdd from "../components/common/lyyymmdd";
import showHide from "../components/common/showHide";
import alotItem from "../../node_modules/common/src/components/alotItem";
import tableForm from "../../node_modules/common/src/components/tableForm";
import selectFlow from "../components/diaodu/selectFlow";

import lySearch from "../../node_modules/common/src/components/lySearch";
import dataDetail from "../../node_modules/common/src/components/dataDetail";
import imgList from "../../node_modules/common/src/components/imgList";

function plugins(Vue) {
  Vue.component("groupTree", groupTree);
  Vue.component("iSwitchLy", iSwitchLy);
  Vue.component("userTree", userTree);
  Vue.component("reportTop", reportTop);
  Vue.component("reportTools", reportTools);
  Vue.component("carTool", carTool);
  Vue.component("personTool", personTool);
  Vue.component("payTool", payTool);
  Vue.component("timeTool", timeTool);
  Vue.component("selectGroup", selectGroup);
  Vue.component("selectUser", selectUser);
  Vue.component("selectCar", selectCar);
  Vue.component("selectCarType", selectCarType);
  Vue.component("selectPerson", selectPerson);
  Vue.component("lyTable", lyTable);
  Vue.component("selectDevice", selectDevice);
  Vue.component("deviceTool", deviceTool);
  Vue.component("selectItems", selectItems);
  Vue.component("selectGrid", selectGrid);
  Vue.component("lyGroup", lyGroup);
  Vue.component("lyItem", lyItem);
  Vue.component("lyFormItem", lyFormItem);
  Vue.component("lykanbanbox", lykanbanbox);
  Vue.component("lyList", lyList);
  Vue.component("axiosRes", axiosRes);
  Vue.component("lyMap", lyMap);
  Vue.component("pointList", pointList);
  Vue.component("fenceList", fenceList);
  Vue.component("lineList", lineList);
  Vue.component("photo", photo);
  Vue.component("lyPhoto", lyPhoto);
  Vue.component("word", word);
  Vue.component("startEnd", startEnd);
  Vue.component("selectTool", selectTool);
  Vue.component("searchAdd", searchAdd);
  Vue.component("blind", blind);
  Vue.component("jiedian", jiedian);
  Vue.component("selectAddMap", selectAddMap);
  Vue.component("lySearch", lySearch);
  Vue.component("Address", Address);
  Vue.component("selectCity", selectCity);
  Vue.component("AddressList", AddressList);
  Vue.component("selectFence", selectFence);
  Vue.component("selectPoint", selectPoint);
  Vue.component("selectLine", selectLine);
  Vue.component("selecAlotCCar", selecAlotCCar);
  Vue.component("selectAlotGroup", selectAlotGroup);
  Vue.component("showHide", showHide);
  Vue.component("formModel", formModel);
  Vue.component("tableForm", tableForm);
  Vue.component("selectFlow", selectFlow);
  Vue.component("lyyymmdd", lyyymmdd);
  Vue.component("alotItem", alotItem);
  Vue.component("selectDriver", selectDriver);
  Vue.component("driverTool", driverTool);
  Vue.component("dataDetail", dataDetail);
  Vue.component("imgList", imgList);
  Vue.component("toggle", toggle);
}

export default plugins;



// WEBPACK FOOTER //
// ./src/util/person.js